import { Accordion as MuiAccordion } from '@mui/material'
import { AccordionProps } from './Accordions.types'
import { SourceSiteDetails } from 'Features/Project/WorkcentreModal/WorkcentreModal.types'
import { AccordionSummary } from 'Features/Project/WorkcentreModal/AccordionSummary/AccordionSummary.view'
import { AccordionDetails } from 'Features/Project/WorkcentreModal/AccordionDetails/AccordionDetails.view'
import { isAnyWorkCentresSelected } from 'Features/Project/WorkcentreModal/WorkcentreModal.utils'

export const Accordions = ({
  sourceSiteDetails,
  handleCheckboxChange,
  readOnly,
}: AccordionProps) => {
  const Accordion = (data: SourceSiteDetails) => {
    return (
      <MuiAccordion
        defaultExpanded={readOnly}
        sx={{
          minWidth: '700px',
          border: `1px solid #e0e0e0`,
          borderRadius: '3px',
          borderBottom: 'none',
          boxShadow: 'none',
          marginBottom: '10px',
          '&:before': {
            display: 'none',
          },
          '&.Mui-expanded': {
            margin: '10px 0px',
          },
        }}
        key={data.siteKey}
      >
        <AccordionSummary
          readOnly={readOnly}
          sourceSiteData={data}
          handleCheckboxChange={handleCheckboxChange}
        />
        <AccordionDetails
          readOnly={readOnly}
          sourceSiteData={data}
          handleCheckboxChange={handleCheckboxChange}
        />
      </MuiAccordion>
    )
  }

  return (
    <>
      {sourceSiteDetails.map((data) =>
        readOnly
          ? isAnyWorkCentresSelected(data.siteWorkcentres)
            ? Accordion(data)
            : null
          : Accordion(data)
      )}
    </>
  )
}
